import { DocumentoField } from '@components/Fields/DocumentoField';
import { Fieldset } from '@components/Fields/Fieldset';
import { StringField } from '@components/Fields/StringField';
import { TelefoneField } from '@components/Fields/TelefoneField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { VerticalGrid } from '@components/VerticalGrid';
import { IForm } from '@hooks/useForm';
import { IVendedorEditar } from '@services/VendedorService';
import React from 'react';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';

export type VendedorFichaFormProps = {
    form: IForm<IVendedorEditar>
}

export function VendedorFichaForm ({ form }: VendedorFichaFormProps) {
    const { fields } = form;

    return (
        <VerticalGrid>
            <Fieldset
                icon={<AssignmentIndIcon />}
                title="Identificação"
                hasMarginTop={false}
            >
                <HorizontalGrid spacing={2}>
                    <GridItem xs={6}>
                        <StringField 
                            field={fields.nome}
                            label="Nome"
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <DocumentoField 
                            maskType="cpf"
                            field={fields.cpf}
                            label="CPF"
                        />
                    </GridItem>
                </HorizontalGrid>
            </Fieldset>

            <Fieldset
                icon={<ImportContactsIcon />}
                title="Contato"
            >
                <HorizontalGrid spacing={2}>
                    <GridItem xs={3}>
                        <TelefoneField
                            maskType="cel" 
                            field={fields.telefone}
                            label="Telefone"
                        />
                    </GridItem>
                </HorizontalGrid>
            </Fieldset>
        </VerticalGrid>
    )
}